export const PRODUCT_STATES = [
  { value: '', label: 'Всі статуси' },
  { value: 'ACTIVE', label: 'Доступний для замовлення' },
  { value: 'OUT_OF_STOCK', label: 'Тимчасово недоступний' },
  { value: 'SOLD_OUT', label: 'Знятий з продажу' },
  { value: 'PREORDER', label: 'Передзамовлення' },
  { value: 'INACTIVE', label: 'Не активний' }
];

export const NUMBER_PER_PAGE = 50;

/** Значення для фільтра "Категорія знижки" — товари без категорії (null або пустий рядок). */
export const DISCOUNT_CATEGORY_EMPTY = '__EMPTY__';

export const INITIAL_SELECTED_PRODUCT = {
  id: "",
  productCode: "",
  barcode: "",
  packBarcode: "",
  packQuantity: "",
  name: "",
  description: "",
  price: "",
  quantity: "",
  discount: 0,
  parentId: null,
  priceInPounds: "",
  priceInUSD: "",
  priceInEuro: "",
  purchasePrice: "",
  expectedArrivalDate: "",
  manufacturerUrl: "",
  state: "",
  discountCategoryName: "",
  categoryIds: [],
  images: []
};
